<div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden">
    <div class="filter-chip-container tw-flex tw-flex-col tw-p-4">
        <mat-chip-listbox #chipList
            (change)="onFilterStatusChange($event.value)"
            [value]="currentStatus()"
            required="true">
            @for(s of statusConfig; track s.status) {
                <mat-chip-option [value]="s.status"
                    class="custom-chip tw-px-2 tw-py-0.5 tw-rounded-full tw-font-bold">
                    <div class="tw-flex tw-items-center tw-justify-between">
                        <span>{{ s.label }}</span>
                        <span class="chip-badge">{{ s.count }}</span>
                    </div>
                </mat-chip-option>
            }

        </mat-chip-listbox>
    </div>

    <div class="tw-flex-1 tw-min-h-0">
        <app-grid-client-side
            #integrationsGridComponent
            [headerCheckboxSelection]="true"
            (areRowsSelected)="handleSelectionChange($event)"
            (rowClicked)="rowClicked($event)"
            [hidden]="!gridPath"
            [tableData]="tableData[0]"
            [fixedButtons]="fixedButtons"
            (gridReadyEmitter)="onGridReady()"
            (filterChangedEmitter)="onFilterChangedEmitter($event)"
            [exportFormatterOptions]="exportFormatterOptions"
            (clickableAction)="actions($event)"
            feature="history_sales_data_sent"
        ></app-grid-client-side>
    </div>
</div>